module.exports = __webpack_public_path__ + "img/bx-grade-choosings.c289117a.svg";